// Make sure FAB is defined
window.FABNAMESPACE = 'FAB';
window[window.FABNAMESPACE] = window.window[window.FABNAMESPACE] || {};
